<div>
  <div class="filter-div">
    <ng-select
      [items]="noteTypes"
      [(ngModel)]="selectedTypes"
      [multiple]="true"
      (change)="filterNotes()"
      bindValue="type"
      placeholder="Filter by type"
      appendTo="body">
      <ng-template ng-option-tmp let-item="item">
        <span class="options">{{ item.label }} ({{ item.count }})</span>
      </ng-template>
    </ng-select>
  </div>

  <div class="notes">
    <ng-container *ngIf="filteredNotes.length > 0">
      <ng-container *ngFor="let note of filteredNotes">
        <p style="margin-bottom: 0; grid-template-columns: auto 1fr; display: grid; gap: 15px" *ngIf="note.note">
          <!--Icon-->
          <i *ngIf="note.type === 'answer'" class="fa fa-comment" title="Question Comments/Notes"></i>
          <i
            *ngIf="note.type === 'inspection'"
            class="fa fa-institution"
            title="Inspection created Note (only visible to inspector)"></i>
          <i *ngIf="note.type === 'flag'" class="fa fa-flag" title="Flag Notes"></i>
          <i *ngIf="note.type === 'flag-group'" class="fa fa-group" title="Flag Group Internal Notes"></i>
          <i *ngIf="note.type === 'flag-internal'" class="fa fa-flag-checkered" title="Flag Internal Notes"></i>
          <i *ngIf="note.type === 'flag-review'" class="fa fa-circle" title="Underwriting Review Comment"></i>
          <!--Note-->
          <a *ngIf="note.type === 'inspection'" (click)="scrollToNotes()" style="color: #2763cd">{{ note.note }}</a>
          <a
            *ngIf="note.type === 'flag-group' || note.type === 'flag-review' || note.type === 'flag-internal'"
            [routerLink]="['/inspection/review/flagManager', note.inspectionId]"
            [queryParams]="{ groupId: note.groupId, flagId: note.flagId }"
            target="_blank"
            >{{ note.note }}</a
          >
          <a
            *ngIf="note.type === 'answer' || note.type === 'flag'"
            [routerLink]="['/inspection/review/main/', note.inspectionId]"
            target="_blank"
            [queryParams]="{
              item: note.itemIndex,
              section: note.sectionIndex,
              question: note.questionIndex,
              right: 'question'
            }">
            {{ note.note }}</a
          >
        </p>
        <p
          style="
            grid-template-columns: 15px 1fr;
            display: grid;
            gap: 15px;
            font-size: 13px;
            color: #444;
            margin-bottom: 10px;
          "
          *ngIf="note.note">
          <span style="flex: 1"></span>
          <span style="flex: 9">{{ formatDate(note.date) }} / {{ note.user }}</span>
        </p>
      </ng-container>
    </ng-container>
  </div>
</div>
